import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { Classroom } from 'bookraw/shared/models/classroom.model';
import { environment } from 'env/environment';
import { timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class ClassroomService extends ListService<Classroom> {

  url: string = '/api/admin/classroom';

  import(courseIds: string[]) {
    return this.http.post(environment.baseURL + this.url + '/import', {
      courseIds: courseIds
    });
  }

  show(courseId: string|number) {
    return this.http.get(environment.baseURL + this.url + '/import/' + courseId)
  }

  getBusyCourseState(courseId: string|number) {
    
    return timer(1000,5000).pipe(
      switchMap( () => this.show(courseId) )
    )
  }
}
